import type { FunctionComponent, ReactNode } from 'react';
import { Fragment } from 'react';

import { useTranslate } from '~/shared/context/use-translate';

import { InviteTeamMemberDialog } from '../../company-settings/tabs/organization-tab/users-and-roles/InviteTeamMemberDialog';
import { JOB_ARCHITECTURE_INVITATION_ROLES, useInviteTeamMember } from '../api/use-invite-team-member';

type Props = {
    readonly architectureId: string;
    readonly children: (props: { readonly openInviteDialog: () => void }) => ReactNode;
    readonly itemId: string;
    readonly itemType: 'job-level' | 'job-role';
};

export const InviteTeamMemberForJobItem: FunctionComponent<Props> = ({
    architectureId,
    children,
    itemId,
    itemType,
}) => {
    const translate = useTranslate();
    const { availableMethods, closeInviteDialog, handleInvite, isInviteDialogOpen, openInviteDialog } =
        useInviteTeamMember({ architectureId, itemId, itemType });

    return (
        <Fragment>
            {children({ openInviteDialog })}
            <InviteTeamMemberDialog
                allowedRoles={JOB_ARCHITECTURE_INVITATION_ROLES}
                availableMethods={availableMethods}
                open={isInviteDialogOpen}
                title={translate('pages.company-settings.users-and-roles.invite-dialog.assign-review-title')}
                onClose={closeInviteDialog}
                onInvite={handleInvite}
            />
        </Fragment>
    );
};
